// frontend/src/hooks/useDynamicTranslation.js

import { useState, useCallback, useContext } from 'react'; 
import { useTranslation } from 'react-i18next';
import { AuthContext } from "../../contexts/AuthContext";


export const useDynamicTranslation = (originalText) => {
    const { i18n } = useTranslation();
    const { fetchWithAuth } = useContext(AuthContext);
    const [translatedText, setTranslatedText] = useState(null);
    const [isTranslating, setIsTranslating] = useState(false);
    const [translationError, setTranslationError] = useState(null);

    // The manual translate function remains the same.
    // The backend already checks the cache first, so this is still efficient.
    const handleTranslate = useCallback(async () => {
        if (!originalText || i18n.language === 'en') return;

        setIsTranslating(true);
        setTranslationError(null);
        try {
            const response = await fetchWithAuth('/api/translate', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    text: originalText,
                    target_language: i18n.language,
                }),
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.error || 'Translation failed');
            setTranslatedText(data.translated_text);
        } catch (err) {
            console.error("Dynamic translation error:", err);
            setTranslationError(err.message);
        } finally {
            setIsTranslating(false);
        }
    }, [originalText, i18n.language, fetchWithAuth]);

    const textToShow = translatedText || originalText;

    // --- SIMPLIFIED RETURN VALUE ---
    // We no longer need isCheckingCache.
    return {
        textToShow,
        isTranslating,
        translationError,
        handleTranslate,
        needsTranslation: i18n.language !== 'en' && !translatedText,
    };
};